import React, { useState } from 'react';
import { AppBar, Toolbar, Grid, Button, IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
import { Home as HomeIcon, Menu as MenuIcon } from '@mui/icons-material';
import logo from './logo.png';
import { Link } from 'react-router-dom';
import { useDevice } from 'components/DeviceContext.js';

const Navbar = () => {
    const { isMobile } = useDevice();
    const [drawerOpen, setDrawerOpen] = useState(false);


    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    };

    const menuItems = (
        <>
            <ListItem button component={Link} to="/">
                <HomeIcon style={{ marginRight: '10px' }} />
                <ListItemText primary="Home" />
            </ListItem>
            <ListItem button component={Link} to="/palavra-do-presidente">
                <ListItemText primary="Palavra do presidente" />
            </ListItem>
            <ListItem button component={Link} to="/declaracoes">
                <ListItemText primary="Declarações" />
            </ListItem>

            <ListItem button component={Link} to="/galeria">
                <ListItemText primary="Galeria" />
            </ListItem>
        </>
    );

    return (
        <AppBar position="static" style={{ backgroundColor: 'var(--azul)', padding: '1em', userSelect: 'none' }}>
            <Toolbar>
                <Grid container alignItems="center" style={{ justifyContent: isMobile ? 'space-between' : 'space-around'}}>
                    <Link to="/">
                        <img style={{ width: isMobile ? '200px' : '' }} src={logo} alt="logo Mobilizacao municipalista" />
                    </Link>
                    {isMobile ? (
                        <IconButton edge="end" color="inherit" aria-label="menu" onClick={handleDrawerToggle}>
                            <MenuIcon />
                        </IconButton>
                    ) : (
                        <Grid item style={{ color: 'var(--branco)', alignSelf: 'center', display: 'flex', gap: '10px' }}>
                            <Link to="/" style={{ textDecoration: 'none', color: 'var(--branco)'}}>
                            <IconButton edge="start" color="inherit" aria-label="home">
                                <HomeIcon />
                            </IconButton>
                            </Link>
                            <Button color="inherit" component={Link} to="/palavra-do-presidente">Palavra do presidente</Button>
                            <Button color="inherit" component={Link} to="/declaracoes">Declarações</Button>
                            <Button color="inherit" component={Link} to="/galeria">Galeria</Button>
                        </Grid>
                    )}
                </Grid>
            </Toolbar>
            <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerToggle}>
                <List>
                    {menuItems}
                </List>
            </Drawer>
        </AppBar>
    );
};

export default Navbar;
